import React from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
const GeneratePayrollFilters = ({
  type,
  name,
  label,
  placeholder,
  currentValue,
  options,
  updateQueryParams,
}) => {
  switch (type) {
    case "select":
      return (
        <div className="form-floating">
          <Select
            placeholder={placeholder}
            className="select "
            options={options}
            onChange={(selectedOptions) => {
              updateQueryParams(name, selectedOptions);
            }}
            showSearch
            // style={{ width: "200px", fontSize: "12px", height: "30px" }}
            allowClear
            size="medium"
            // onClear={() => {
            //   updateQueryParams("employeeCode", 0);
            // }}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
          {/* <label className="form-label">{label}</label> */}
        </div>
      );

    default:
      return null;
  }
};

export default GeneratePayrollFilters;

GeneratePayrollFilters.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  currentValue: PropTypes.any,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateQueryParams: PropTypes.func.isRequired,
};
